import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { tripSlice } from 'src/features/trip/trip.slice';

import { useTripCancelReasonsForTripWithBulkCancel } from './useTripCancelReasonsForTripWithBulkCancel';

export function TripReasonCell({ tripId }: { tripId: string }) {
  const { reasons } = useTripCancelReasonsForTripWithBulkCancel(tripId);
  const dispatch = useAppDispatch();
  const selectedTripReasons = useAppSelector(
    (state) => state.trip.bulkCancelModal.selectedTripReasons
  );

  return (
    <div data-testid={`cancel-reason-select-for-trip-${tripId}`}>
      <Select
        options={reasons}
        value={selectedTripReasons[tripId] || undefined}
        onChange={(option) => {
          if (option) {
            dispatch(
              tripSlice.actions.setBulkCancelReasons({
                ...selectedTripReasons,
                [tripId]: option.value,
              })
            );
          }
        }}
      />
    </div>
  );
}
